/**
 * TextEditor (text display block) builder — verbatim from v1
 * (research/03 §8; REQ-ELEM-2). Note the stray space before ><label.
 */
import { appState } from "../state/app-state";
import { getConditionalDisplay, getToolTipHtml , getElementWidthClass, t , dirAttr } from "./base";

export function buildTextDisplayBlock(element: any): string {
  var textValue = element.TextValue != undefined ? t(element.TextValue) : "";
  var conditionalDisplay = getConditionalDisplay(element);
  let toolTipHtml = getToolTipHtml(element, "span");

  return (
    "<div class='element" + getElementWidthClass(element) + "' data-element='" +
    element.Identifier +
    "' " +
    conditionalDisplay.conditionalTemplate +
    " ><label style='color:" +
    appState.calculatorStyling.upperTextColor +
    "'" + dirAttr(element.TextValue) + ">" +
    textValue +
    toolTipHtml +
    "</label></div>"
  );
}
